import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { Projet } from '../models/actionsCollectives/projets/projet'

const baseResource = 'entreprises'
const resource = 'Projets'

export default class ProjetsResource {
  public async paginatedList(entrepriseId: string, pagenumber?: number, pagesize?: number, search?: string) : Promise<PaginatedList<Projet>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (search && search.length) params.append('Search', search?.toString()); 

    const response = await api.get(`${baseResource}/${entrepriseId}/${resource}`, { params: params } )
    return response.data
  }

  public async getById(entrepriseId: string, id : string) : Promise<Projet> {
    const response = await api.get(`${baseResource}/${entrepriseId}/${resource}/${id}`)
    return response.data
  }

  public async delete(entrepriseId: string, id : string) : Promise<Projet> {
    const response = await api.delete(`${baseResource}/${entrepriseId}/${resource}/${id}`)
    return response.data
  }

  public async post(entrepriseId: string, data : Projet) : Promise<Projet> {
    const response = await api.post(`${baseResource}/${entrepriseId}/${resource}`, data)
    return response.data
  }

  public async put(entrepriseId: string, id : string, data : Projet) : Promise<Projet> {
    const response = await api.put(`${baseResource}/${entrepriseId}/${resource}/${id}`, data)
    return response.data
  }
}
